import { Route } from '@angular/router';

import { DemoShellComponent } from './demos/demo-shell';
import { DemoApplicationShellComponent } from './demos/demo-application-shell';
import { DemoLayoutComponent } from './demos/demo-layout';
import { DemoGridComponent } from './demos/demo-grid';
import { DemoFormControlsComponent } from './demos/demo-form-controls';
import { DemoSelectComponent } from './demos/demo-select';
import { DemoMediaComponent } from './demos/demo-media';
import { DemoNavigationComponent } from './demos/demo-navigation';
import { DemoFormLayoutComponent } from './demos/demo-form-layout';

import { DemoUppInputComponent } from './demos/widgets/demo-upp-input';
import { DemoUppInputSelectComponent } from './demos/widgets/demo-upp-input-select';
import { DemoUppTextareaComponent } from './demos/widgets/demo-upp-textarea';
import { DemoUppSearchComponent } from './demos/widgets/demo-upp-search';
import { DemoUppSelectComponent } from './demos/widgets/demo-upp-select';
import { DemoUppPanelComponent } from './demos/widgets/demo-upp-panel';
import { DemoUppDialogComponent } from './demos/widgets/demo-upp-dialog';
import { DemoUppHeaderComponent } from './demos/widgets/demo-upp-header';
import { DemoUppSideMenuComponent } from './demos/widgets/demo-upp-side-menu';
import { DemoUppApplicationComponent } from './demos/widgets/demo-upp-application';
import { DemoUppDropdownComponent } from './demos/widgets/demo-upp-dropdown';
import { DemoUppScrollableComponent } from './demos/widgets/demo-upp-scrollable';
import { DemoUppVisibleControlComponent } from './demos/widgets/demo-upp-visible-control';
import { DemoUppGridComponent } from './demos/widgets/demo-upp-grid';
import { DemoUppThumbComponent } from './demos/widgets/demo-upp-thumb';
import { DemoUppImageComponent } from './demos/widgets/demo-upp-image';
import { DemoUppFormComponent } from './demos/widgets/demo-upp-form';
import { DemoUppTabBarComponent } from './demos/widgets/demo-upp-tab-bar';
import { DemoUppAddressComponent } from './demos/widgets/demo-upp-address';
import { DemoUppButtonBarComponent } from './demos/widgets/demo-upp-button-bar';
import { DemoUppDatePickerComponent } from './demos/widgets/demo-upp-date-picker';
import { DemoUppTimeComponent } from './demos/widgets/demo-upp-time';
import { DemoUppChartComponent } from './demos/widgets/demo-upp-chart';
import { DemoUppColorComponent } from './demos/widgets/demo-upp-color';
import { DemoUppBarcodeDisplayComponent } from './demos/widgets/demo-upp-barcode-display';
import { DemoUppScaleInputComponent } from './demos/widgets/demo-upp-scale-input';
import { uppBaseTesterComponent } from './tester/test-base';
import { DemoKonvaComponent } from '@unpispas/upp-konva-demo';

export const appRoutes: Route[] = [
    // Home: the original test page
    { path: '', component: uppBaseTesterComponent },

    // Shell-wrapped routes (for browsing demos with sidebar navigation)
    { path: 'demo', component: DemoShellComponent, children: [
        { path: '', pathMatch: 'full', redirectTo: 'application-shell' },
        { path: 'application-shell', component: DemoApplicationShellComponent },
        { path: 'layout', component: DemoLayoutComponent },
        { path: 'grid', component: DemoGridComponent },
        { path: 'form-controls', component: DemoFormControlsComponent },
        { path: 'select', component: DemoSelectComponent },
        { path: 'media', component: DemoMediaComponent },
        { path: 'navigation', component: DemoNavigationComponent },
        { path: 'form-layout', component: DemoFormLayoutComponent },
        { path: 'upp-input', component: DemoUppInputComponent },
        { path: 'upp-input-select', component: DemoUppInputSelectComponent },
        { path: 'upp-textarea', component: DemoUppTextareaComponent },
        { path: 'upp-search', component: DemoUppSearchComponent },
        { path: 'upp-select', component: DemoUppSelectComponent },
        { path: 'upp-panel', component: DemoUppPanelComponent },
        { path: 'upp-dialog', component: DemoUppDialogComponent },
        { path: 'upp-header', component: DemoUppHeaderComponent },
        { path: 'upp-side-menu', component: DemoUppSideMenuComponent },
        { path: 'upp-application', component: DemoUppApplicationComponent },
        { path: 'upp-dropdown', component: DemoUppDropdownComponent },
        { path: 'upp-scrollable', component: DemoUppScrollableComponent },
        { path: 'upp-visible-control', component: DemoUppVisibleControlComponent },
        { path: 'upp-grid', component: DemoUppGridComponent },
        { path: 'upp-thumb', component: DemoUppThumbComponent },
        { path: 'upp-image', component: DemoUppImageComponent },
        { path: 'upp-form', component: DemoUppFormComponent },
        { path: 'upp-tab-bar', component: DemoUppTabBarComponent },
        { path: 'upp-address', component: DemoUppAddressComponent },
        { path: 'upp-button-bar', component: DemoUppButtonBarComponent },
        { path: 'upp-date-picker', component: DemoUppDatePickerComponent },
        { path: 'upp-time', component: DemoUppTimeComponent },
        { path: 'upp-chart', component: DemoUppChartComponent },
        { path: 'upp-color', component: DemoUppColorComponent },
        { path: 'upp-scale-input', component: DemoUppScaleInputComponent },
        { path: 'konva', component: DemoKonvaComponent },
    ]},

    // Standalone routes (no shell) — used by documentation iframes
    { path: 'widget/upp-input', component: DemoUppInputComponent },
    { path: 'widget/upp-input-select', component: DemoUppInputSelectComponent },
    { path: 'widget/upp-textarea', component: DemoUppTextareaComponent },
    { path: 'widget/upp-search', component: DemoUppSearchComponent },
    { path: 'widget/upp-select', component: DemoUppSelectComponent },
    { path: 'widget/upp-panel', component: DemoUppPanelComponent },
    { path: 'widget/upp-dialog', component: DemoUppDialogComponent },
    { path: 'widget/upp-header', component: DemoUppHeaderComponent },
    { path: 'widget/upp-side-menu', component: DemoUppSideMenuComponent },
    { path: 'widget/upp-application', component: DemoUppApplicationComponent },
    { path: 'widget/upp-dropdown', component: DemoUppDropdownComponent },
    { path: 'widget/upp-scrollable', component: DemoUppScrollableComponent },
    { path: 'widget/upp-visible-control', component: DemoUppVisibleControlComponent },
    { path: 'widget/upp-grid', component: DemoUppGridComponent },
    { path: 'widget/upp-thumb', component: DemoUppThumbComponent },
    { path: 'widget/upp-image', component: DemoUppImageComponent },
    { path: 'widget/upp-form', component: DemoUppFormComponent },
    { path: 'widget/upp-tab-bar', component: DemoUppTabBarComponent },
    { path: 'widget/upp-address', component: DemoUppAddressComponent },
    { path: 'widget/upp-button-bar', component: DemoUppButtonBarComponent },
    { path: 'widget/upp-date-picker', component: DemoUppDatePickerComponent },
    { path: 'widget/upp-time', component: DemoUppTimeComponent },
    { path: 'widget/upp-chart', component: DemoUppChartComponent },
    { path: 'widget/upp-color', component: DemoUppColorComponent },
    { path: 'widget/upp-barcode-display', component: DemoUppBarcodeDisplayComponent },
    { path: 'widget/upp-scale-input', component: DemoUppScaleInputComponent },
    { path: 'widget/konva', component: DemoKonvaComponent },
];
